/* global angular */
( function () {
	'use strict';

	function groupSearch ( focusModel, $window ) {
		function link ( scope ) {
			function computeOffset ( ev ) {
				ev.preventDefault();

				if ( !angular.element( '.obs-header' ).find( '.panel-body' ).is( ':visible' ) ) {
					scope.defaultOffset = 140;
				} else {
					scope.defaultOffset = 275;
				}
			}

			function tapGroupPager ( group ) {
				$window.scrollTo( 0, 0 );
				focusModel.set( group );
			}

			scope.computeOffset = computeOffset;
			scope.tapGroupPager = tapGroupPager;
			scope.isEnabled     = focusModel.isValid;

			scope.isFocused = focusModel.isFocusedModel;
		}

		return {
			'link'        : link,
			'restrict'    : 'E',
			'templateUrl' : '/templates/components/groupSearch/groupSearch.html',
			'scope'       : {
				'groups' : ' = ',

				'addGroupTemplate' : '=',
				'onTemplate'       : '=',
				'groupState'       : '=',
				'isViewOnlyMode'   : '='
			}
		};
	}

	angular
		.module( 'app.components' )
		.run( groupSearch )
		.directive( 'groupSearch', groupSearch );

	groupSearch.$inject = [ 'groupPagerFactory', '$window' ];
} )( );
